import React, { Fragment, useEffect, useRef, useState } from "react";

import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import { Toast } from "primereact/toast";
import { Loading } from "app/components";

import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  createPayment,
  deleteSubscription,
  getSubscription,
  getSubscriptionList,
  getUserCounts,
  saveDetails,
  saveFeatureText,
  saveSubscription,
  scheduleDowngrade,
  updateStatus,
  validateCoupon,
  verifyPayment
} from "./subscription.service";
import { classNames } from "primereact/utils";
import { TreeTable } from "primereact/treetable";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

import {
  CardElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import { getSessionUserInformation } from "app/utils/utility.service";

import "./Subscription.css";
import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { formatDate } from "app/utils/utility.service";
import { NumericFormat } from "react-number-format";
import { RadioButton } from "primereact/radiobutton";
import { inviteAgent } from "../clients/clients.service";
import Coupons from "./Coupons/Coupons";
import { getAgentClientCount, getBrokerAgentCount } from "../sessions/session.service";
import { SuccessToastConfig } from "app/utils/ToastConstants";
import { ErrorToastConfig } from "app/utils/ToastConstants";
import { validateEmail } from "app/utils/utility.service";


const Subscription = ({ isDialog = false,onHide }) => {


  const [showSponsoredDialog, setShowSponsoredDialog] = useState(false);
  const [showClientLimitDialog, setShowClientLimitDialog] = useState(false);
   const [showAgentLimitDialog, setShowAgentLimitDialog] = useState(false);
  const [sponsoredAgent, setSponsoredAgent] = useState({ firstName: '', lastName: '', email: '', phone: '', companyName: '' });
  const [sponsoredEmailError, setSponsoredEmailError] = useState('');
  const [sponsoredFormErrors, setSponsoredFormErrors] = useState({});
  const [details, setDetails] = useState("");
  const [hasAddon, setHasAddon] = useState(false);
  const [coupon, setCoupon] = useState("");
  const getSubscriptionDetails = async () => {
    const sessionValues = getSessionUserInformation();
    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues.id;

    console.log(" broker id "+sessionValues.brokerId)
    let detailsSub = await getSubscription(userId);
    if (!!detailsSub) {

      setDetails(detailsSub);
      

    }
    setIsLoading(false);
  };

  const handleSponsoredSelect = () => {
    setShowSponsoredDialog(true);
  };


  const handleSponsoredDialogClose = () => {
    setShowSponsoredDialog(false);
    setSponsoredAgent({ firstName: '', lastName: '', email: '', phone: '', companyName: '' });
  };

  const handleClientLimitDialogClose = () => {
    setShowClientLimitDialog(false);
  };

  const handleClientLimitDialogConfirm = () => {
    setShowClientLimitDialog(false);
    navigate("/clients");
  };

  const handleAgentLimitDialogClose = () => {
    setShowAgentLimitDialog(false);
  };

  const handleAgentLimitDialogConfirm = () => {
    setShowAgentLimitDialog(false);
    navigate("/agents");
  };
  


  const handleSponsoredInputChange = (e) => {
    const { name, value } = e.target;
    setSponsoredAgent((prev) => ({ ...prev, [name]: value }));
    if (name === 'email') {
      setSponsoredEmailError('');
    }
    // Clear error for this field when user starts typing
    if (sponsoredFormErrors[name]) {
      setSponsoredFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };


  const handleSponsoredSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous errors
    setSponsoredFormErrors({});
    setSponsoredEmailError('');
    
    // Validate mandatory fields
    const errors = {};
    if (!sponsoredAgent.firstName.trim()) {
      errors.firstName = 'First Name is required';
    }
    if (!sponsoredAgent.lastName.trim()) {
      errors.lastName = 'Last Name is required';
    }
    if (!sponsoredAgent.email.trim()) {
      errors.email = 'Email is required';
    } else if (!validateEmail(sponsoredAgent.email)) {
      setSponsoredEmailError('Please enter a valid email address');
      return false;
    }
    
    if (Object.keys(errors).length > 0) {
      setSponsoredFormErrors(errors);
      return false;
    }

    setIsLoading(true);
    setShowSponsoredDialog(false);
    let req = sponsoredAgent;
    req.id = sessionValues.id;
    req.brokerId = sessionValues.brokerId;
    req.senderName = sessionValues?.firstName +  " " + sessionValues?.lastName;
    let res = await inviteAgent(req);
   
    if (res?.status) {
      setDetails({
        ...details,
        is_active: true
      });
    }
    setIsLoading(false);
    showSuccess('Your invitation has been sent successfully. You’ll receive sponsored account status once your agent approves it. Until then, please continue using your existing subscription plan.');
  };

  const addcoupon = async () => {
    if (!coupon.trim()) {
      showError("Please enter a coupon code");
      return;
    }

    try {
      console.log('Validating coupon:', coupon);

      let payload = {
        role: sessionValues.roleId,
        code: coupon
      };
      let result = await validateCoupon(payload);


      if (result.data?.valid) {
        showSuccess(`Coupon "${coupon.trim()}" applied successfully! You saved ${result.discount || '10%'}`);
        setCoupon(''); // Clear input after success


      } else {
        
        showError(result.data?.message);
      }
    } catch (error) {
      console.error('Error validating coupon:', error);
      showError('Failed to validate coupon. Please try again.');
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [searchParams] = useSearchParams();
  const clientId = searchParams.get("clientid");
  const isAgentView = searchParams.get('agent') !== null;
  const isBrokerView = searchParams.get('broker') !== null;
  const [features, setFeatures] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const sessionValues = getSessionUserInformation();
  const [plans, setPlans] = useState([]);
  const [clientPlans, setClientPlans] = useState([]);
  const [agentPlans, setAgentPlans] = useState([]);
  const [brokerPlans, setBrokerPlans] = useState([]);
  const toast = useRef();
  const [values, setValues] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("Free");
  const [isSelectedPlanAddon, setisSelectedPlanAddon] = useState(false);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [selectedCycle, setSelectedCycle] = useState("annual");
  const [selectedPlanId, setSelectedPlanId] = useState(1);
  const [annualPrice, setAnnualPrice] = useState(0);
  const [users, setUsers] = useState([]);
  const [cardReady, setCardReady] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("idle");
  const [treeData, setTreeData] = useState([]);
  const [expandedKeys, setExpandedKeys] = useState({});
  const [isTreeLoading, setIsTreeLoading] = useState(false);
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();


   const showSuccess = (message) => {
		toast.current.show(SuccessToastConfig(message));
	};

	const showError = (message) => {
		toast.current.show(ErrorToastConfig(message ? message : "Error"));
	};
  useEffect(() => {
    setIsLoading(true);
    getUsers();
    getSubscriptionDetails();
    fetchSubscriptions();


  }, []);
  const getUsers = async () => {

    let users = await getUserCounts();
    setUsers(users.data);
  };
  
  const [freeClientPlan, setFreeClientPlan] = useState(null);
  const [freeAgentPlan, setFreeAgentPlan] = useState(null);
  const [freeBrokerPlan, setFreeBrokerPlan] = useState(null);
  const [isDowngrade, setIsDowngrade] = useState(false);
  const [isCardComplete, setIsCardComplete] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [cardError, setCardError] = useState(null);
  const [brokerMaxAgentLimit,setBrokerMaxAgentLimit] = useState(0);
  const fetchSubscriptions = async () => {
    setIsTreeLoading(true);

    const userId =
      clientId && clientId !== "null" ? clientId : sessionValues.id;
    let detailsSub = await getSubscription(userId);
    if (!!detailsSub) {

      setDetails(detailsSub);
      setHasAddon(detailsSub.addon);

    }
    let hasPaidSubscription = false;

     if(sessionValues.roleId === 3) {
      const storedSubscription = sessionStorage.getItem("subscriptionData");
      const parsedSubscription = storedSubscription ? JSON.parse(storedSubscription) : null;
      hasPaidSubscription = parsedSubscription.hasPaidSubscription;
     }

    let list = await getSubscriptionList();
    if (list) {
      setIsLoading(false);
   
      
      // Filter plans by plan_type - only get relevant plans for this component
      const clientPlansFiltered = list.plans.filter(plan => plan.plan_type === 'client');
      let agentPlansFiltered = list.plans.filter(plan =>
    sessionValues.roleId === 1
        ? plan.plan_type === 'agent'
        : (
            sessionValues.brokerId != null && sessionValues.brokerId !== 0
                ? (
                    plan.plan_type === 'agent' &&
                    (
                        sessionValues.status === 'Active'
                            ? plan.plan_category === 'addon'
                            : (
                                (plan.plan_category === 'base' || plan.plan_category == null) ||
                                (plan.plan_category === 'addon' && hasPaidSubscription)
                            )
                    )
                )
                : (
                    plan.plan_type === 'agent' &&
                    (plan.plan_category === 'base' || plan.plan_category == null)
                )
        )
);
      const brokerPlansFiltered = list.plans.filter(plan => plan.plan_type === 'broker');

      // If agent is associated with broker, get broker's current subscription and add that plan to agent plans
      if (sessionValues.brokerId != null && sessionValues.brokerId !== 0 && sessionValues.roleId !== 1 && sessionValues.status !== 'Approval Pending') {
        try {
          const brokerSubscription = await getSubscription(sessionValues.brokerId);
          setBrokerMaxAgentLimit(brokerSubscription?.subscription_plan?.max_clients_per_agent);
        } catch (error) {
          console.error("Error fetching broker subscription:", error);
        }
      }

      // Find the free plan (monthly_price: 0, annual_price: 0) for each role
      const freeClientPlan = clientPlansFiltered.find(plan => 
        (plan.monthly_price == "0.00") && (plan.annual_price == "0.00")
      );
      const freeAgentPlan = agentPlansFiltered.find(plan => 
        (plan.monthly_price == "0.00") && (plan.annual_price == "0.00")
      );
      const freeBrokerPlan = brokerPlansFiltered.find(plan => 
        (plan.monthly_price == "0.00") && (plan.annual_price == "0.00")
      );

      setFreeClientPlan(freeClientPlan);
      setFreeAgentPlan(freeAgentPlan);
      setFreeBrokerPlan(freeBrokerPlan);

      // Find the free plan (monthly_price: 0, annual_price: 0)
      const freePlan = clientPlansFiltered.find(plan => 
        plan.monthly_price === 0 && plan.annual_price === 0
      );
      
      setClientPlans(clientPlansFiltered);
      setAgentPlans(agentPlansFiltered);
      setBrokerPlans(brokerPlansFiltered);

      // Add categories to features
      const featuresWithCategories = list.features.map(feature => ({
        ...feature,
        category: feature.category || "Free"
      }));
      setFeatures(featuresWithCategories);

      // Use static tree structure instead of dynamic transformation
      const treeStructure = transformToTreeData(list.plans, featuresWithCategories);
      setTreeData(treeStructure);

      // Auto-expand all categories
      const autoExpandedKeys = {};
      treeStructure.forEach(category => {
        autoExpandedKeys[category.key] = true;
      });
      setExpandedKeys(autoExpandedKeys);
      setIsTreeLoading(false);

      if (detailsSub) {

        let selectedPlanSub = list.plans.find(p => p.id === detailsSub.plan_id);
        setSelectedPlan(selectedPlanSub.name);
        setSelectedPlanId(detailsSub.plan_id);
        setSelectedCycle(detailsSub.billing_cycle);
        setMonthlyPrice(detailsSub.subscription_plan.monthly_price);
        setAnnualPrice(detailsSub.subscription_plan.annual_price);
      } else {
        // Auto-select default plan based on view type
        if (isAgentView && agentPlansFiltered.length > 0) {
          const defaultAgentPlan = agentPlansFiltered.find(plan => plan.is_default === "1") || agentPlansFiltered[0];
          setSelectedPlan(defaultAgentPlan.name);
          setSelectedPlanId(defaultAgentPlan.id);
          setMonthlyPrice(defaultAgentPlan.monthly_price);
          setAnnualPrice(defaultAgentPlan.annual_price);
        } else if (isBrokerView && brokerPlansFiltered.length > 0) {
          const defaultBrokerPlan = brokerPlansFiltered.find(plan => plan.is_default === "1") || brokerPlansFiltered[0];
          setSelectedPlan(defaultBrokerPlan.name);
          setSelectedPlanId(defaultBrokerPlan.id);
          setMonthlyPrice(defaultBrokerPlan.monthly_price);
          setAnnualPrice(defaultBrokerPlan.annual_price);
        } else if (clientPlansFiltered.length > 0) {
          const defaultClientPlan = clientPlansFiltered.find(plan => plan.is_default === "1") || clientPlansFiltered[0];
          setSelectedPlan(defaultClientPlan.name);
          setSelectedPlanId(defaultClientPlan.id);
          setMonthlyPrice(defaultClientPlan.monthly_price);
          setAnnualPrice(defaultClientPlan.annual_price);
        }
      }

    }
  };

  // Transform flat data structure to tree structure for TreeTable
  const transformToTreeData = (plans, features) => {
    // Group features by category
    const featuresByCategory = features.reduce((acc, feature) => {
      const category = feature.category || "General Features";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(feature);
      return acc;
    }, {});

    // Create tree structure with categories as main nodes
    const treeStructure = Object.keys(featuresByCategory).map(category => ({
      key: category,
      data: {
        name: category,
        type: 'category',
        category: category
      },
      children: featuresByCategory[category].map(feature => ({
        key: `${category}-${feature.id}`,
        data: {
          id: feature.id,
          name: feature.name,
          type: 'feature',
          category: category,
          access: feature.access
        }
      }))
    }));

    return treeStructure;
  };
  const handleSave = async (e) => {
    e.preventDefault();
     const userId =
      clientId && clientId !== "null" ? clientId : sessionValues.id;

    if( sessionValues.roleId === 3 ) {
     let clientCount = await getAgentClientCount(userId);
      
      // Check if client count exceeds selected plan's max clients
      const selectedPlanDetails = agentPlans.find(plan => plan.id === selectedPlanId);
      const maxClients = selectedPlanDetails?.max_clients || 0;
      
      if (clientCount.data > maxClients) {
        setShowClientLimitDialog(true);
        setIsLoading(false);
        return;
      }
    }

   
    let params = {};
    params.userId = userId;
    params.targetPlanId = selectedPlanId;
    params.schedule = selectedCycle;

    //let res = await saveSubscription(params);
    let res = await scheduleDowngrade(params);  
    if (res.status) {
      fetchSubscriptions();
      showSuccess(`You are currently in the subscription period. Your plan will switch to ${selectedPlan} on ${new Date(details.end_date).toLocaleDateString()}. Until then you will continue in your current plan.`);
    } else {
      showError(res?.message);
    }

  };
  const handleSubmit = async (e, editingData) => {
    e.preventDefault();
    let params = {};
    params.name = editingData.name;
    params.monthly_price = values.monthlyPrice;
    params.annual_price = values.annualPrice;
    const mappings = [];

    features.forEach((feature) => {
      Object.entries(feature.access).forEach(([planName, enabled]) => {
        mappings.push({
          planName,
          featureId: feature.id,
          enabled,
        });
      });
    });
    params.mappings = mappings;
    params.id = editingData.id;
    let res = await saveDetails(params);
    if (res.status) {
      showSuccess("Details updated successfully");
    } else {
      showError(res?.message);
    }
    await fetchSubscriptions();
  };


  const toggleFeature = (featureId, plan, checked) => {
    setFeatures((prevFeatures) => {
      return prevFeatures.map((feature) => {
        if (feature.id === featureId) {
          return {
            ...feature,
            access: {
              ...feature.access,
              [plan.name]: checked,
            },
          };
        }
        return feature;
      });
    });

    // Also update treeData to reflect changes
    setTreeData((prevTreeData) => {
      return prevTreeData.map(category => ({
        ...category,
        children: category.children.map(feature => {
          if (feature.data.id === featureId) {
            return {
              ...feature,
              data: {
                ...feature.data,
                access: {
                  ...feature.data.access,
                  [plan.name]: checked,
                }
              }
            };
          }
          return feature;
        })
      }));
    });
  };
  const handleInputChange = (name, e) => {
    let value = e.target.value.replace(/[$,]/g, "");

    setValues({
      ...values,
      [name]: parseFloat(value),
    });
  };
  const handleSubscribe = async () => {
    setIsLoading(true);
    // Handle free plans differently
    if (selectedPlan?.trim()?.toLowerCase() === freeClientPlan?.name?.toLowerCase() ||
      selectedPlan?.trim()?.toLowerCase() === freeAgentPlan?.name?.toLowerCase() ||
      selectedPlan?.trim()?.toLowerCase() === freeBrokerPlan?.name?.toLowerCase()) {

      handleSave(new Event('submit'));
      return;
    }

    // Check if it's a downgrade (current plan is more expensive than selected plan)
    const currentPlanPrice = details.subscription_plan ?
      (selectedCycle === "monthly" ? details.subscription_plan.monthly_price : details.subscription_plan.annual_price) : 0;
    const selectedPlanPrice = selectedCycle === "monthly" ? monthlyPrice : annualPrice;

    // Determine if it's a downgrade
    const isDowngrade = currentPlanPrice > selectedPlanPrice;
    setIsDowngrade(isDowngrade);

    const userId = clientId && clientId !== "null" ? clientId : sessionValues.id;
    // If selected plan is cheaper, it's a downgrade - schedule it
    if (currentPlanPrice > selectedPlanPrice) {
      if (sessionValues.roleId === 3) {
        let clientCount = await getAgentClientCount(userId);

        // Check if client count exceeds selected plan's max clients
        const selectedPlanDetails = agentPlans.find(plan => plan.id === selectedPlanId);
        const maxClients = selectedPlanDetails?.max_clients || 0;

        if (clientCount.data > maxClients) {
          setShowClientLimitDialog(true);
          setIsLoading(false);
          return;
        }
      } else if (sessionValues.roleId === 2) {
        let clientCount = await getBrokerAgentCount(userId);

        // Check if client count exceeds selected plan's max clients
        const selectedPlanDetails = brokerPlans.find(plan => plan.id === selectedPlanId);
        const maxClients = selectedPlanDetails?.max_clients || 0;

        if (clientCount.data > maxClients) {
          setShowAgentLimitDialog(true);
          setIsLoading(false);
          return;
        }
      }
      let params = {};
      params.userId = userId;
      params.targetPlanId = selectedPlanId;
      params.schedule = selectedCycle;

      let res = await scheduleDowngrade(params);
      if (res.status) {
        setIsLoading(false);
        showSuccess(`You are currently in the subscription period. Your plan will switch to ${selectedPlan} on ${new Date(details.end_date).toLocaleDateString()}. Until then you will continue in your current plan.`);
        return;
      }
    } else {

      // Prevent multiple submissions for paid plans
      if (isProcessing || !stripe || !elements) {
        return;
      }



      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        showError("Please enter card details");
        return;
      }

      try {
        const payload = {
          name: sessionValues.firstName + " " + sessionValues.lastName,
          userId: userId,
          planId: selectedPlanId,
          email: sessionValues.email,
          billing_cycle: selectedCycle,
          role: sessionValues.roleId,
          amount: selectedCycle === "monthly" ? monthlyPrice : annualPrice,
          coupon: coupon || null, // Add coupon to payload
          // Required for Indian export regulations
          address: {
            line1: sessionValues.address || "N/A",
            city: sessionValues.city || "N/A",
            state: sessionValues.state || "N/A",
            postal_code: sessionValues.postalCode || "000000",
            country: "US"
          }
        };

        const data = await createPayment(payload);

        setIsProcessing(true);

        if (data.clientSecret) {
          if (data.message == "Payment Initiated") {
            const confirmPayment = await stripe.confirmCardPayment(
              data.clientSecret,
              {
                payment_method: {
                  card: cardElement,
                  billing_details: {
                    name: sessionValues.firstName + " " + sessionValues.lastName,
                    email: sessionValues.email,
                    address: {
                      line1: sessionValues.address || "N/A",
                      city: sessionValues.city || "N/A",
                      state: sessionValues.state || "N/A",
                      postal_code: sessionValues.postalCode || "000000",
                      country: "US"
                    }
                  }
                }
              }
            );

            const { paymentIntent } = confirmPayment;
            if (paymentIntent?.status === "succeeded") {
              const payload = {
                paymentIntentId: paymentIntent.id,
                userId: userId,
                planId: selectedPlanId,
                billing_cycle: selectedCycle,
              };
              let res = await verifyPayment(payload);
              //  await updateStatus({ user_id: userId, plan_id: selectedPlanId, billing_cycle:selectedCycle });

              if (res?.couponInfo) {
                showSuccess("A discount of $" + res?.couponInfo?.discountAmount + " has been applied successfully.Your subscription plan has been updated successfully. To reflect the latest plan features, please log out and log in again.")
              } else {
                showSuccess(`A payment of $${res.finalAmount} has been made on your card.Your subscription plan has been updated successfully. To reflect the latest plan features, please log out and log in again.`);
              }
              setPaymentStatus("success");
              fetchSubscriptions();
              setIsProcessing(false);
              setCoupon("");
              cardElement.clear();
            } else if (confirmPayment.error) {
              console.log("ERROR")
              showError(confirmPayment.error.message);
              setPaymentStatus("error");
              setIsProcessing(false);
              setErrorMessage(confirmPayment.error.message);
            } else {
              showError("Payment failed. Please try again.");
              setPaymentStatus("error");
              setIsProcessing(false);
            }
            setIsLoading(false);

          }
        } // ============================================
        // CASE 2 - SETUP INTENT EXISTS
        // ============================================

        else if (data.setupIntentClientSecret) {

          const confirmSetup =
            await stripe.confirmCardSetup(
              data.setupIntentClientSecret,
              {
                payment_method: {
                  card: cardElement,

                  billing_details: {
                    name:
                      sessionValues.firstName +
                      " " +
                      sessionValues.lastName,

                    email: sessionValues.email
                  }
                }
              }
            );

          if (confirmSetup.error) {

            showError(
              confirmSetup.error.message
            );

            setPaymentStatus("error");

            setIsProcessing(false);

            return;
          }

          if (
            confirmSetup.setupIntent?.status ===
            "succeeded"
          ) {

             let res = await updateStatus({ user_id: userId, plan_id: selectedPlanId, billing_cycle: selectedCycle });
             if (
                res?.data?.id
            ) {

              if (data?.discountApplied) {
                showSuccess("A discount of $" + data?.discountApplied?.discount + " has been applied successfully. Your subscription plan has been updated successfully. To reflect the latest plan features, please log out and log in again.");
              } else {
                showSuccess(`Your subscription plan has been updated successfully. To reflect the latest plan features, please log out and log in again.`);
              }
               setIsLoading(false);
              setPaymentStatus("success");
              fetchSubscriptions();
              setIsProcessing(false);
              setCoupon("");
              cardElement.clear();
            }
          }
        }
        // ============================================
        // CASE 3 - NO PAYMENT NEEDED
        // ============================================

        else if (
          data.invoiceStatus === "paid"
        ) {

          let res = await updateStatus({ user_id: userId, plan_id: selectedPlanId, billing_cycle: selectedCycle });
          if (
                res?.data?.id 
            ) {

              showSuccess(`Your subscription plan has been updated successfully. To reflect the latest plan features, please log out and log in again.`);
               setIsLoading(false);
              setPaymentStatus("success");
              fetchSubscriptions();
              setIsProcessing(false);
              setCoupon("");
              cardElement.clear();
            }
        }
        else {

          showError(data?.data?.message);
          setIsProcessing(false);
          setIsLoading(false);
        }
      } catch (err) {
        console.error("Payment error:", err);
        setErrorMessage(err.message || "Payment processing failed");
        setIsProcessing(false);
        setPaymentStatus("error");
        setIsLoading(false);
        showError("There was an error in payment processing");

      }
    }
  };

  
  const stripeStyle = {
    style: {
      base: {
      
        color: "#32325d",
        width: "20vw",
        fontSize:"12px",
        fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif",
        "::placeholder": {
          color: "#a0aec0",
        },
        

      },
      invalid: {
        color: "#e53e3e",
      },
    },
    hidePostalCode: true,
  };

  return (
    <div className="table-demo center-align">
      {isLoading && <Loading />}
      <Toast ref={toast} className="ToastMessage" />

      {isTreeLoading ? (
        <div className="flex justify-content-center align-items-center" style={{ height: "400px" }}>
          <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "#666" }}></i>
        </div>
      ) : (
        !isDialog ? (
          <Fragment>

            <SubscriptionTabs users={users} clientPlans={clientPlans} agentPlans={agentPlans} brokerPlans={brokerPlans} features={features}
              setPlans={setPlans} selectedPlan={selectedPlan} values={values}
              fetchSubscriptions={fetchSubscriptions} showSuccess={showSuccess} showError={showError}
              treeData={treeData} setTreeData={setTreeData} toggleFeature={toggleFeature} isDialog={isDialog}
              setClientPlans={setClientPlans} setAgentPlans={setAgentPlans} setBrokerPlans={setBrokerPlans}
              setSelectedPlan={setSelectedPlan} setSelectedPlanId={setSelectedPlanId} setMonthlyPrice={setMonthlyPrice}
              setAnnualPrice={setAnnualPrice} selectedCycle={selectedCycle} isAgentView={isAgentView} isBrokerView={isBrokerView}
              handleSubmit={handleSubmit} plans={plans} stripe={stripe} selectedPlanId={selectedPlanId}  />
          </Fragment>
        ) : (
          <Fragment>
              {sessionValues.roleId === 3 && sessionValues.brokerId != null && sessionValues.brokerId !== 0 && clientId === null && sessionValues.status !== 'Approval Pending' && (
                <div className="broker-info-banner">
                  <i className="pi pi-info-circle info-icon"></i>

                  <span>
                      Your broker has allowed you to add up to
                      <strong> {brokerMaxAgentLimit} clients </strong>
                      under the current plan. Once the limit is reached,
                      please contact your broker or subscribe to an
                      <strong> Extended Client Pack </strong>
                      to continue adding clients.
                  </span>
              </div>
            )}
            <div style={{ overflow: "hidden" }} className="flex gap-5 justify-content-center mb-5">
               {(isBrokerView ? brokerPlans : isAgentView ? agentPlans : clientPlans).filter(plan => {
                const now = new Date();
                const startDate = plan.startDate ? new Date(plan.startDate) : null;
                const endDate = plan.endDate ? new Date(plan.endDate) : null;
                const isActiveFlag = plan.is_active === "1";
                
                // Check if plan is active based on flag and date range
                if (!isActiveFlag) return false;
                
                // If no dates specified, consider it active
                if (!startDate && !endDate) return true;
                
                // Check date range
                if (startDate && endDate) {
                  return now >= startDate && now <= endDate;
                } else if (startDate) {
                  return now >= startDate;
                } else if (endDate) {
                  return now <= endDate;
                }
                
                return true;
              }).map(plan => (
                <div style={{ borderRadius: '1.5rem', margin: '8px 8px' }} key={plan.name}>
                  <PricingTierCard
                    title={plan.name}
                    isAddOn={plan.plan_category === "addon"}
                    plans={isBrokerView ? brokerPlans : isAgentView ? agentPlans : clientPlans}
                    price={selectedCycle === "monthly" ? plan.monthly_price : plan.annual_price}
                    features={plan.features || []}
                    selected={selectedPlan === plan.name}
                    showClientRange={isBrokerView || isAgentView}
                    details={details}
                    brokerMaxAgentLimit={brokerMaxAgentLimit}
                    clientRangeLabel={isBrokerView ? "Agents" : "Clients"}
                    sessionValues={sessionValues}
                    hasAddon={hasAddon}
                    onSelect={() => {
                      if (plan.name.toLowerCase() === 'sponsored') {
                        setSelectedPlan(plan.name);
                        setSelectedPlanId(plan.id);
                        setMonthlyPrice(plan.monthly_price);
                        setAnnualPrice(plan.annual_price);
                        setIsCardComplete(true);
                        handleSponsoredSelect();
                      } else {
                        setSelectedPlan(plan.name);
                        setSelectedPlanId(plan.id);
                        setisSelectedPlanAddon(plan.plan_category === "addon" ? true: false);
                        setMonthlyPrice(plan.monthly_price);
                        setAnnualPrice(plan.annual_price);

                         // Check if it's a downgrade (current plan is more expensive than selected plan)
                        const currentPlanPrice = details.subscription_plan ? 
                          (selectedCycle === "monthly" ? details.subscription_plan.monthly_price : details.subscription_plan.annual_price) : 0;
                        const selectedPlanPrice = selectedCycle === "monthly" ? plan.monthly_price : plan.annual_price;
                        
                        // Determine if it's a downgrade
                        const isDowngrade = plan.plan_category !== "addon" ? currentPlanPrice > selectedPlanPrice : false;
                        setIsDowngrade(isDowngrade);
                        if(isDowngrade) setIsCardComplete(true);
                        else setIsCardComplete(false);
                        
                      }
                    }}
                  />
                </div>
              ))}
            </div>
            {/* Sponsored Plan Dialog */}
            <Dialog
              header="Agent Invitation"
              visible={showSponsoredDialog}
              style={{ width: '50vw', height: '50vh' }}
              onHide={handleSponsoredDialogClose}
              closable={true}
              modal={true}
              className="p-dialog-agent-details"
            >
              <label style={{ marginTop:"1rem",fontSize: "1.4rem", "fontWeight": "600" }}>You will receive the Sponsored Plan once your Financial Agent adds you as a client in the MyHouser application. To proceed, please enter your Agent’s details so we can send an invitation.
              </label>
              <div className="flex flex-column gap-1 mt-4" style={{ "gap": "2rem" }}>
                <div className="flex gap-3" style={{ "gap": "3rem" }}>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <InputText
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={sponsoredAgent.firstName}
                      onChange={handleSponsoredInputChange}
                      required={true}
                      className="vw-inputtext-with-border"
                    />
                    {sponsoredFormErrors.firstName && (
                      <small className="p-error" style={{ marginTop: '4px' }}>
                        {sponsoredFormErrors.firstName}
                      </small>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <InputText
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={sponsoredAgent.lastName}
                      onChange={handleSponsoredInputChange}
                      required={true}
                      className="vw-inputtext-with-border"
                    />
                    {sponsoredFormErrors.lastName && (
                      <small className="p-error" style={{ marginTop: '4px' }}>
                        {sponsoredFormErrors.lastName}
                      </small>
                    )}
                  </div>
                </div>
                <div className="flex gap-3" style={{ "gap": "3rem" }} >
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <InputText
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={sponsoredAgent.email}
                      onChange={handleSponsoredInputChange}
                      required={true}
                      className="vw-inputtext-with-border"
                    />
                    {(sponsoredFormErrors.email || sponsoredEmailError) && (
                      <small className="p-error" style={{ marginTop: '4px' }}>
                        {sponsoredFormErrors.email || sponsoredEmailError}
                      </small>
                    )}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <InputText
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      value={sponsoredAgent.phone}
                      onChange={handleSponsoredInputChange}
                      required={true}
                      pattern="[0-9]{10}"
                      className="vw-inputtext-with-border"
                    />
                  </div>
                </div>
                <div>
                  <InputText style={{ "width": "48%" }}
                    name="companyName"
                    placeholder="Company Name"
                    value={sponsoredAgent.companyName}
                    onChange={handleSponsoredInputChange}
                    required={true}
                    pattern="[0-9]{10}"
                    className="vw-inputtext-with-border"
                  />
                </div>
              </div>
              <Button
                type="submit"
                label="Cancel"
                onClick={handleSponsoredDialogClose}
                className="p-button-raised p-button-lg"
                style={{ marginTop: 8 }}
              />
              <Button
                type="submit"
                label="Send Invitation"
                onClick={handleSponsoredSubmit}
                className="ml-3 p-button-warning p-button-raised p-button-lg"
                style={{ marginTop: 15 }}
              />

            </Dialog>

          {/* Client Limit Dialog */}
          <Dialog
            header="Client Limit Exceeded"
            visible={showClientLimitDialog}
            style={{ width: '50vw' }}
            onHide={handleClientLimitDialogClose}
            closable={true}
            modal={true}
            className="p-dialog-agent-details"
          >
            <div style={{ marginBottom: "1rem" }}>
              You currently have more clients than the selected plan allows. To proceed with the downgrade, please remove the excess clients from your account.
            </div>
            <div style={{ marginBottom: "1.5rem", color: "#666" }}>
              Would you like to go to the Client Management page now?
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <Button
                label="Cancel"
                onClick={handleClientLimitDialogClose}
                className="p-button-raised p-button-lg"
                style={{ marginTop: 8,marginBottom:15 }}
              />
              <Button
                label="Go to Clients"
                onClick={handleClientLimitDialogConfirm}
                className="p-button-warning p-button-raised p-button-lg"
                style={{ marginTop: 8, marginBottom:15 }}
              />
            </div>
          </Dialog>
          {/* Agent Limit Dialog */}
          <Dialog
            header="Agent Limit Exceeded"
            visible={showAgentLimitDialog}
            style={{ width: '50vw' }}
            onHide={handleAgentLimitDialogClose}
            closable={true}
            modal={true}
            className="p-dialog-agent-details"
          >
            <div style={{ marginBottom: "1rem" }}>
              You currently have more agents than the selected plan allows. To proceed with the downgrade, please remove the excess agents from your account.
            </div>
            <div style={{ marginBottom: "1.5rem", color: "#666" }}>
              Would you like to go to the agent management page now?
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <Button
                label="Cancel"
                onClick={handleAgentLimitDialogClose}
                className="p-button-raised p-button-lg"
                style={{ marginTop: 8,marginBottom:15 }}
              />
              <Button
                label="Go to Agents"
                onClick={handleAgentLimitDialogConfirm}
                className="p-button-warning p-button-raised p-button-lg"
                style={{ marginTop: 8, marginBottom:15 }}
              />
            </div>
          </Dialog>
        </Fragment>
        )

      )}
    
   
      {isDialog ? (
       <div className="subscription-dialog-container">
          <Divider></Divider>
        <Fragment>
          <div className="flex align-items-center mb-5 subscription-row">

    <div className="subscription-label">
        <label className="fontLabel bold">
            Billing Cycle -
        </label>
    </div>

    <div className="subscription-content">
        {!isSelectedPlanAddon ? (
        <div className="flex align-items-center mr-4">
            <RadioButton
                inputId="monthly"
                name="billing"
                value="monthly"
                className="mr-2"
                onChange={(e) => setSelectedCycle(e.value)}
                checked={selectedCycle === "monthly"}
            />
            <label htmlFor="monthly" className="fontLabel">
                Monthly
            </label>
        </div>
        ) : null}
        <div className="flex align-items-center mr-4">
            <RadioButton
                inputId="annual"
                name="billing"
                value="annual"
                className="mr-2"
                onChange={(e) => setSelectedCycle(e.value)}
                checked={selectedCycle === "annual"}
            />
            <label htmlFor="annual" className="fontLabel">
                Yearly
            </label>
        </div>

        <NumericFormat
            prefix="$ "
            thousandSeparator=","
            decimalScale={2}
            style={{ background: "white" }}
            className="input-field"
            value={
                selectedCycle === "monthly"
                    ? monthlyPrice
                    : annualPrice
            }
            disabled={true}
            onBlur={(e) => {
                handleInputChange("annualPrice", e);
            }}
        />

    </div>

</div>
          {/* Coupon Input Field */}
          <div className="flex align-items-center mb-5 subscription-row">
          
            <div className="subscription-label">
              <label className="fontLabel bold">Coupon Code - </label>
            </div>
            <div className="subscription-content">
              <InputText
                type="text"
                className="vw-inputtext-with-border"
                autoComplete="off"
                style={{
                 width: "260px",
                  backgroundColor: "white",
                  opacity: title.indexOf("Edit") !== -1 ? 0.6 : 1,
                  borderRadius: 0,
                  color:"#000"
                }}
                disabled={selectedPlan?.trim()?.toLowerCase() === "free" 
                  || selectedPlan?.trim()?.toLowerCase() === "sponsored" || details.subscription_plan?.name?.trim()?.toLowerCase() === selectedPlan?.trim()?.toLowerCase()
                || selectedPlan?.trim()?.toLowerCase() === "sponsored" || 
                details.subscription_plan?.name?.trim()?.toLowerCase() === selectedPlan?.trim()?.toLowerCase() || 
                (selectedPlan?.trim()?.toLowerCase() === freeClientPlan?.name?.toLowerCase() || 
                selectedPlan?.trim()?.toLowerCase() === freeAgentPlan?.name?.toLowerCase() || 
                selectedPlan?.trim()?.toLowerCase() === freeBrokerPlan?.name?.toLowerCase() || isDowngrade)
                }

                value={coupon}
                onChange={(e) => setCoupon(e.target.value)}
              />
            </div>

          </div>

         <div className="flex align-items-center mb-4 subscription-row">

    <div className="subscription-label">
        <label className="fontLabel bold">
            Payment Method -
        </label>
    </div>

    <div className="subscription-content payment-content">

        <img src="/mastercard.jpg" alt="Company" />
        <img src="/amex.jpg" alt="Company" />
        <img src="/visa.jpg" alt="Company" />
        <img src="/discover.jpg" alt="Company" className="ml-2" />

        <div className={`stripe-field ${isFocused ? 'focused' : ''}`}>

            <CardElement
                options={{
                    ...stripeStyle,
                    disabled:
                        selectedPlan?.trim()?.toLowerCase() === "free" ||
                        selectedPlan?.trim()?.toLowerCase() === "sponsored" ||
                        details.subscription_plan?.name?.trim()?.toLowerCase() === selectedPlan?.trim()?.toLowerCase() || 
                (selectedPlan?.trim()?.toLowerCase() === freeClientPlan?.name?.toLowerCase() || 
                selectedPlan?.trim()?.toLowerCase() === freeAgentPlan?.name?.toLowerCase() || 
                selectedPlan?.trim()?.toLowerCase() === freeBrokerPlan?.name?.toLowerCase()) || 
                isDowngrade 
                }}
               
                onReady={() => {
                    setCardReady(true);
                }}
                onChange={(event) => {

                    if (event.complete) {
                        setIsCardComplete(true);
                    } else {
                        setIsCardComplete(false);
                    }

                    if (event.error) {
                        setCardError(event.error.message);
                    } else {
                        setCardError(null);
                    }
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />

        </div>
        {sessionValues.roleId === 4 ? (
        <Button
              label="Cancel"
              style={{"minWidth":"3rem"}}
              className="p-button-raised p-button-lg"
              onClick={() => onHide()}
            />
        ) : null}
        <Button
            label="Save"
            className="p-button-raised p-button-warning p-button-lg"
            onClick={handleSubscribe}
             style={sessionValues.roleId === 4 ? { minWidth: "3rem" } : {}}
            disabled={
                !stripe ||
                !elements ||
                isProcessing ||
                selectedPlan.toLowerCase() === "sponsored" ||
                details.subscription_plan?.name === selectedPlan ||
                !isCardComplete ||
                !!cardError
            }
        />

    </div>

</div>
        </Fragment>
        </div>
      ) : null}
    </div>
  );
};

const PricingTierCard = ({
  title,
  isAddOn,
  plans,
  price,
  features,
  selected,
  onSelect,
  details,
  showClientRange = false,
  brokerMaxAgentLimit,
  clientRangeLabel = "Clients",
  sessionValues,
  hasAddon
}) => {

  // Generate tier summaries from plan FeaturesTexts
  const tierSummaries = plans.reduce((acc, plan) => {
    // Handle both string arrays and object arrays
    const features = plan.FeaturesTexts || [];
    acc[plan.name] = features.map(feature =>
      typeof feature === 'string' ? feature : feature.feature_text_display || feature.feature_text || ''
    ).filter(Boolean); // Remove empty strings
    return acc;
  }, {});

  const header = (
    <div className="relative text-center">

      <div className="text-4xl font-bold mt-3">
        {title.toUpperCase()}
      </div>

      {/* Show min/max clients if available and showClientRange is true */}
      {showClientRange && (() => {
        const plan = plans.find(p => p.name === title);
        if (plan && plan.min_clients && plan.max_clients) {
          return (
            <div className="text-4xl font-bold mt-4">

              {plan.min_clients === plan.max_clients
                ? `${plan.max_clients} ${clientRangeLabel}`
                : `${plan.min_clients} - ${plan.max_clients} ${clientRangeLabel}`
              }

            </div>
          );
        }
        return null;
      })()}

      {/* Show plan upgrade option for agents */}
      {clientRangeLabel === 'Agents' && (() => {
        const plan = plans.find(p => p.name === title);
        if (plan && plan.min_clients_per_agent && plan.max_clients_per_agent) {
          return (
            <div className="mt-4">
              <div className="flex flex-column align-items-center text-4xl font-bold mt-4">
               
                  {plan.min_clients_per_agent} - {plan.max_clients_per_agent} Clients per Agent
                
              </div>
            </div>
          );
        }
        return null;
      })()}

      <div className="mt-4">
        <div className="flex flex-column align-items-center">
          {title.toLowerCase() !== 'sponsored' && (
            <Fragment>
              {!isAddOn ? (
              <div className="flex align-items-center mb-2">
                <span className="text-4xl font-bold">${plans.find(p => p.name === title)?.monthly_price || 0}</span>
                <span className="text-lg text-500">/month</span>
              </div>
              ) : null}
              <div className="flex align-items-center mt-3">
                <span className="text-4xl font-bold">
                  ${plans.find(p => p.name === title)?.annual_price || 0}
                </span>
                <span className="text-lg text-500" >/year</span>
              </div>
            </Fragment>
          )}
        </div>
      </div>

      {/* Dynamic feature list for all tiers */}
      {tierSummaries[title] && tierSummaries[title].length > 0 && (
        <ul
          className="list-none m-2 mb-4 mt-4"
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}
        >
          {tierSummaries[title].map((summary, idx) => (
            <li
              key={idx}
              className="mb-2 m-2"
              style={{ display: 'flex', alignItems: 'start', justifyContent: 'center', fontSize: '1.15rem', fontFamily: 'Inter, Arial, sans-serif', fontWeight: 500, color: '#32325d' }}
            >
              <i className="pi pi-check text-orange-500 mr-2"></i>
              {summary}
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <Fragment>
    
    <Card
      header={header}
      className={classNames(
        "shadow-2 border-round-xl",
        {
          "border-2 border-orange-200": selected,
          "surface-card": !selected
        }
      )}
      style={{ width: "300px", borderRadius: "1.5rem", margin: "0 8px", minHeight: "300px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
    >

      <ul className="list-none p-0 m-0 mb-4">
        {features.map((feature, index) => (
          <li key={index} style={{ fontSize: "1.4rem" }} className="flex align-items-center mb-3">
            <i className="pi pi-check-circle text-orange-500 mr-2"></i>
            {feature}
          </li>
        ))}
      </ul>

      <Button
        label={details.subscription_plan?.name == title ? "Current Plan" : (title.toLowerCase() === 'sponsored' ? (details?.is_active ? "Agent Invited" : "Invite Agent") : "Select Plan")}
        className="w-full p-button-raised p-button-warning"
        onClick={onSelect}
        disabled={(title.toLowerCase() === 'sponsored' && details?.is_active) || details.subscription_plan?.name == title || (sessionValues.roleId == 3 && isAddOn && hasAddon)}
      />

    </Card>
    </Fragment>
  );
};
const SubscriptionTabs = ({
  stripe,
  users,
  plans,
  features,
  setPlans,
  selectedPlan,
  values,
  fetchSubscriptions,
  showSuccess,
  showError,
  treeData,
  setTreeData,
  isDialog,
  toggleFeature,
  handleSubmit,
  clientPlans,
  agentPlans,
  brokerPlans,
  setClientPlans,
  setAgentPlans,
  setBrokerPlans,
  setSelectedPlan,
  selectedPlanId,
  setSelectedPlanId,
  setMonthlyPrice,
  setAnnualPrice,
  selectedCycle,
  isAgentView,
  isBrokerView
}) => {
  const [globalFilter, setGlobalFilter] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeIndex, setActiveIndex] = useState(() => {
    // Set initial tab based on URL parameter or view type, default to Clients (1)
    const tabParam = searchParams.get('tab');
    if (isBrokerView) {
      return 3; // Brokers tab
    }
    if (isAgentView) {
      return 2; // Agents tab
    }
    const tabMap = { 'clients': 0, 'agents': 1, 'brokers': 2, 'summary': 3,'coupons':4 };
    return tabMap[tabParam] ?? 0;
  });

  // Update URL when tab changes
  const handleTabChange = (e) => {
    setActiveIndex(e.index);
    const tabNames = ['clients', 'agents', 'brokers', 'summary','coupons'];
    setSearchParams({ tab: tabNames[e.index] });
  };
  const [editingPlanId, setEditingPlanId] = useState(null);
  const [editingData, setEditingData] = useState({});
  const [isAddingNew, setIsAddingNew] = useState(false);

  const saveChanges = async () => {
    // Validate all mandatory fields using actual database field names
    const requiredFields = ['name', 'monthly_price', 'annual_price', 'features', 'startDate', 'endDate'];
    const fieldLabels = {
      'name': 'Plan Name',
      'monthly_price': 'Billing Monthly', 
      'annual_price': 'Billing Yearly',
      'features': 'Feature List',
      'startDate': 'Start Date',
      'endDate': 'End Date'
    };
    const missingFields = requiredFields.filter(field => {
      const value = editingData[field];
      if (field === 'features') {
        return !value || (Array.isArray(value) ? value.length === 0 : value.trim() === '');
      }
      return !value || value.toString().trim() === '';
    });

    if (missingFields.length > 0) {
      const missingFieldLabels = missingFields.map(field => fieldLabels[field] || field);
      showError(`Please fill in all required fields: ${missingFieldLabels.join(', ')}`);
      return;
    }

    // Validate date range: end date must be greater than start date
    if (editingData.startDate && editingData.endDate) {
      const startDate = new Date(editingData.startDate);
      const endDate = new Date(editingData.endDate);

      if (endDate <= startDate) {
        showError('End date must be greater than start date');
        return;
      }
    }

    let updatedPlans;
    if (isAddingNew) {
      // For new plans, remove the temporary plan and add the new one
      if (activeIndex === 0) { // Clients tab
        updatedPlans = clientPlans.filter((plan, index) => index !== editingData.index);
        const newPlan = {
          ...editingData,
          isNew: false,
          plan_type: 'client'
        };
        updatedPlans.push(newPlan);
        setClientPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      } else if (activeIndex === 1) { // Agents tab
        updatedPlans = agentPlans.filter((plan, index) => index !== editingData.index);
        const newPlan = {
          ...editingData,
          isNew: false,
          plan_type: 'agent'
        };
        updatedPlans.push(newPlan);
        setAgentPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      } else if (activeIndex === 2) { // Agents tab
        updatedPlans = brokerPlans.filter((plan, index) => index !== editingData.index);
        const newPlan = {
          ...editingData,
          isNew: false,
          plan_type: 'broker'
        };
        updatedPlans.push(newPlan);
        setBrokerPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      }
    } else {
      // For existing plans, update the plan in the appropriate array
      if (activeIndex === 0) { // Clients tab
        updatedPlans = clientPlans.map(plan => {
          if (plan.id === editingPlanId) {
            return {
              ...plan,
              ...editingData
            };
          }
          return plan;
        });
        setClientPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      } else if (activeIndex === 1) { // Agents tab
        updatedPlans = agentPlans.map(plan => {
          if (plan.id === editingPlanId) {
            return {
              ...plan,
              ...editingData
            };
          }
          return plan;
        });
        setAgentPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      } else if (activeIndex === 2) { // Agents tab
        updatedPlans = brokerPlans.map(plan => {
          if (plan.id === editingPlanId) {
            return {
              ...plan,
              ...editingData
            };
          }
          return plan;
        });
        setBrokerPlans(updatedPlans);
        setPlans(updatedPlans); // Also update main plans array
      }
    }
    setEditingPlanId(null);
    setEditingData({});
    setIsAddingNew(false);

    let params = {};
    params.name = editingData.name;
    params.monthly_price = editingData.monthly_price;
    params.annual_price = editingData.annual_price;
    params.startDate = editingData.startDate;
    params.endDate = editingData.endDate;
    params.is_active = editingData.is_active ? "1" : "0";
    params.min_clients = Number(editingData.min_clients);
    params.max_clients = Number(editingData.max_clients);
    params.plan_category = editingData.plan_category;
    params.min_clients_per_agent = editingData.min_clients_per_agent;
    params.max_clients_per_agent = editingData.max_clients_per_agent;

    if (activeIndex === 0) {
      params.plan_type = 'client';
    } else if (activeIndex === 1) {
      params.plan_type = 'agent';
    } else if (activeIndex === 2) {
      params.plan_type = 'broker';
    }

    // For new plans, create default feature mappings
    if (isAddingNew) {
      const mappings = [];
      features.forEach((feature) => {
        // Add mapping for the new plan with default access (disabled)
        mappings.push({
          planName: editingData.name,
          featureId: feature.id,
          enabled: false, // Default to disabled for new plans
        });
      });
      params.mappings = mappings;
    }

    // Ensure featuresArray is properly formatted as string array
    let featuresArray = [];
    if (editingData.featuresArray && editingData.featuresArray.length > 0) {
      // If it's the original object array, convert to string array
      if (typeof editingData.featuresArray[0] === 'object') {
        featuresArray = editingData.featuresArray.map(f => f.feature_text_display || f.feature_text || '');
      } else {
        // If it's already a string array, use it directly
        featuresArray = editingData.featuresArray;
      }
    }

    params.feature_text = featuresArray;
    params.id = editingData.id;
    let res = await saveFeatureText(params);
    if (res.status) {
      showSuccess("Details updated successfully");
    } else {
      showError(res?.message);
    }

    // Store current tab index before data refresh
    const currentTabIndex = activeIndex;

    // Fetch updated data
    await fetchSubscriptions();

    // Ensure we stay on the same tab after data refresh
    // Use requestAnimationFrame to ensure DOM updates are complete
    // requestAnimationFrame(() => {
    setActiveIndex(currentTabIndex);
    // });
  };


  const editableBody = (rowData, field) => {
    // Check if this is the new plan being edited
    const isNewPlanEditing = isAddingNew && editingData?.index === plans?.indexOf(rowData);

    if (editingPlanId === rowData.id || isNewPlanEditing) {
      if (field === 'features') {

        return (
          <InputTextarea
            value={editingData.features || ''}
            onChange={(e) => {
              const textValue = e.target.value;
              // Convert to array format for internal storage
              const featuresArray = textValue.split('\n').filter(line => line.trim());
              setEditingData({
                ...editingData,
                features: textValue, // Keep as string for display
                featuresArray: featuresArray // Store as array for API
              });
            }}
            rows={6}
            style={{

              border: "1px solid #ced4da"
            }}
            placeholder="Enter features (one per line)"

          />
        );
      } else if (field === 'is_active') {
        const statusOptions = [
          { label: 'Active', value: true },
          { label: 'Inactive', value: false }
        ];

        return (
          <Dropdown
            value={editingData.is_active}  // Use existing value as default
            options={statusOptions}
            onChange={(e) => setEditingData({
              ...editingData,
              is_active: e.value
            })}
            optionLabel="label"
            optionValue="value"
            placeholder="Select Status"
            style={{ width: "100%" }}
          />
        );
      }  else if (field === 'plan_category') {
        const statusOptions = [
          { label: 'Base', value: 'base' },
          { label: 'Addon', value: 'addon' }
        ];

        return (
          <Dropdown
            value={editingData.plan_category}  // Use existing value as default
            options={statusOptions}
            onChange={(e) => setEditingData({
              ...editingData,
              plan_category: e.value
            })}
            optionLabel="label"
            optionValue="value"
            placeholder="Select Category"
            style={{ width: "100%" }}
          />
        );
      } else if (field === 'startDate' || field === 'endDate') {
        if(isAddingNew) {
          return (
            <Calendar
              id={`${field}-calendar`}
              minDate={new Date()}
              onChange={(e) => {
                // Convert to local date string to avoid timezone issues
                const localDate = e.value ? new Date(e.value.getTime() - e.value.getTimezoneOffset() * 60000).toISOString().split('T')[0] : null;
                setEditingData({
                  ...editingData,
                  [field]: localDate
                });
              }}
              value={
                editingData[field]
                  ? new Date(formatDate(new Date(editingData[field])))
                  : ""
              }
              showIcon
              style={{ "width": "100%" }}
              dateFormat="mm/dd/yy"
            />
          );
        } else {
            return (
              <span>{rowData[field] ? formatDate(rowData[field]) : '-'}</span>
            );
        }
      } else if(field == 'name') {
        return(
         <InputText
                autoFocus
                className="vw-inputtext-with-border"
                autoComplete="off"
                required={true}
                name="planName"
                value={editingData?.name}
                 onChange={(e) => setEditingData({
                  ...editingData,
                  name: e.target?.value
                })}
                
            />
              );
      }  else if(!isAddingNew && (field === 'monthly_price' || field === 'annual_price')) {
      return (
        <span>{editingData[field] ? editingData[field] : '-'}</span>
      );
      } 
      else {
        const isRequired = ['name', 'monthly_price', 'annual_price', 'startDate', 'endDate'].includes(field);
        const isEmpty = !editingData[field] || editingData[field].toString().trim() === '';
        const isBillingField = ['monthly_price', 'annual_price'].includes(field);

        return (
          <div style={{ position: 'relative', width: '100%' }}>
            {isBillingField && (
              <span
                style={{
                  position: 'absolute',
                  left: '10px',
                  top: '51%',
                  transform: 'translateY(-50%)',
                  zIndex: 1,

                 
                }}
              >
                $
              </span>
            )}
            <NumericFormat
              decimalScale={2}
              value={editingData[field] || ''}
              onChange={(e) => setEditingData({
                ...editingData,
                [field]: e.target.value
              })}
              className={`input-field ${isRequired && isEmpty ? "p-invalid" : ""}`}
              style={{
                width: "100%",
                borderRadius:"3px",
                border: "1px solid #ced4da",
                fontSize:"1.2rem",
                paddingLeft: isBillingField ? '17px' : '10px'
              }}
            />
          </div>
        );
      } 
    }

    // Display mode
    if (field === 'features') {

      return (
        <div>
          {rowData.FeaturesTexts?.map((f, i) => (

            <div key={i}>{f.feature_text_display}</div>
          ))}
        </div>
      );
    } else if (field === 'startDate' || field === 'endDate') {
      return (
        <span>{rowData[field] ? formatDate(rowData[field]) : '-'}</span>
      );
    } else if (field === 'is_active') {
      const statusMap = {
        '1': 'Active',
        '0': 'Inactive',
        'true': 'Active',
        'false': 'Inactive'
      };

      // Ensure the value matches dropdown options
      const displayValue = rowData.is_active;
      const normalizedValue = displayValue === 'true' ? '1' :
        displayValue === 'false' ? '0' :
          displayValue;

      return (
        <span>{statusMap[normalizedValue] || '-'}</span>
      );
    } else if (field === 'plan_category') {

      return (
        <span>{rowData.plan_category || '-'}</span>
      );
    } else {
      const isBillingField = ['monthly_price', 'annual_price'].includes(field);
      const value = rowData[field];

      if (isBillingField && value) {
        return `$${value}`;
      }

      return value || '-';
    }
  };
  const addNewPlan = () => {
    // Check if there's already a new plan being edited
    if (isAddingNew) {
      showError("Please complete or cancel the current new plan before adding another.");
      return;
    }

    // Create a new empty plan without ID
    const newPlan = {
      name: '',
      monthly_price: 0,
      annual_price: 0,
      FeaturesTexts: [],
      startDate: null,
      endDate: null,
      is_active: true,
      isNew: true,
      plan_type: activeIndex === 0 ? 'client' : activeIndex === 2 ? 'agent' : 'broker' // Set plan_type based on active tab
    };

    // Add the new plan to the appropriate array based on active tab
    if (activeIndex === 0) { // Clients tab
      setClientPlans([...clientPlans, newPlan]);
      setPlans([...clientPlans, newPlan]); // Also update main plans array
    } else if (activeIndex === 1) { // Agents tab
      setAgentPlans([...agentPlans, newPlan]);
      setPlans([...agentPlans, newPlan]); // Also update main plans array
    } else if (activeIndex === 2) { // Broker tab
      setBrokerPlans([...brokerPlans, newPlan]);
      setPlans([...brokerPlans, newPlan]); // Also update main plans array
    }

    // Start editing the new plan immediately using index as identifier
    const newPlanIndex = activeIndex === 0 ? clientPlans.length : activeIndex === 1 ? agentPlans.length : brokerPlans.length;
    setEditingPlanId(`new-${newPlanIndex}`);
    setIsAddingNew(true);
    setEditingData({
      name: '',
      monthly_price: 0,
      annual_price: 0,
      features: '', // String for display
      featuresArray: [], // Array for API
      startDate: null,
      endDate: null,
      is_active: true,
      index: newPlanIndex
    });
  };
  const actionBody = (rowData) => {
    // Check if this is the new plan being edited
    const isNewPlanEditing = isAddingNew && editingData?.index === plans?.indexOf(rowData);

    return (editingPlanId === rowData.id || isNewPlanEditing) ? (
      <div className="flex gap-2">
        <i
          className="pi pi-check text-orange-500 cursor-pointer"
          onClick={saveChanges}
          title="Save"
        ></i>
        <i
          className="pi pi-times text-orange-500 cursor-pointer"
          onClick={() => {
            if (isAddingNew) {
              // Remove the new plan if cancelled - use correct array based on active tab
              if (activeIndex === 0) { // Clients tab
                setClientPlans(clientPlans.filter((plan, index) => index !== editingData.index));
                setPlans(clientPlans.filter((plan, index) => index !== editingData.index));
              } else if (activeIndex === 1) { // Agents tab
                setAgentPlans(agentPlans.filter((plan, index) => index !== editingData.index));
                setPlans(agentPlans.filter((plan, index) => index !== editingData.index));
              } else if (activeIndex === 2) { // Agents tab
                setBrokerPlans(brokerPlans.filter((plan, index) => index !== editingData.index));
                setPlans(brokerPlans.filter((plan, index) => index !== editingData.index));
              }
            }
            setEditingPlanId(null);
            setEditingData({});
            setIsAddingNew(false);
          }}
          title="Cancel"
        ></i>
      </div>
    ) : (
      <div className="flex gap-2">
        <i
          className="pi pi-pencil text-orange-500 cursor-pointer"
          onClick={() => openEditor(rowData)}
          title="Edit"
        ></i>
        <i 
          className="pi pi-trash text-orange-600 cursor-pointer" 
          onClick={() => deletePlan(rowData)}
          title="Delete"
        ></i>
      </div>
    );
  };
  const openEditor = (row) => {

    setEditingPlanId(row.id);
    setIsAddingNew(false);
    // Convert FeaturesTexts array to string for editing
    const featuresText = row.FeaturesTexts?.map(f => f.feature_text_display).join('\n') || '';

    setEditingData({
      name: row.name || '',
      monthly_price: row.monthly_price || 0,
      annual_price: row.annual_price || 0,
      features: featuresText, // String for display
      featuresArray: row.FeaturesTexts || [], // Array for API
      startDate: row.startDate || null,
      endDate: row.endDate || null,
      min_clients: row.min_clients || 0,
      max_clients: row.max_clients || 0,
      min_clients_per_agent: row.min_clients_per_agent || 0,
      max_clients_per_agent:row.max_clients_per_agent || 0,
      is_active: row.is_active === '1' || row.is_active === true || row.is_active === 'true',
      id: row.id
    });

  };
  const deletePlan = async (rowData) => {

    try {
      // Call the delete API
      let res = await deleteSubscription(rowData.id);

      // Check if API call was successful
      if (res) {
        // Remove the plan from the appropriate array only after successful API call
        if (activeIndex === 0) { // Clients tab
          const updatedPlans = clientPlans.filter(plan => plan.id !== rowData.id);
          setClientPlans(updatedPlans);
          setPlans(updatedPlans); // Also update main plans array
        } else if (activeIndex === 1) { // Agents tab
          const updatedPlans = agentPlans.filter(plan => plan.id !== rowData.id);
          setAgentPlans(updatedPlans);
          setPlans(updatedPlans); // Also update main plans array
        } else if (activeIndex === 2) { // Agents tab
          const updatedPlans = brokerPlans.filter(plan => plan.id !== rowData.id);
          setBrokerPlans(updatedPlans);
          setPlans(updatedPlans); // Also update main plans array
        }
        showSuccess("Plan deleted successfully");
      } else {
        // Show error message if API call failed
        showError(res?.message || "Failed to delete plan");
      }
    } catch (error) {
      // Handle any errors during the API call
      showError("Error deleting plan: " + (error.message || "Unknown error"));
    }

  };
  const tableHeader = (
    <div className="table-header">

      <span className="p-input-icon-left">
        <i className="pi pi-search " />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search"
        />
      </span>
    </div>
  );

  return (
    <div className="card">

      <TabView
        activeIndex={activeIndex}
        onTabChange={handleTabChange}
      >

        <TabPanel header="Clients" className="clients-tab-content">

          <ClientsPlans
            stripe={stripe}
            plans={plans}
            setPlans={setClientPlans}
            selectedPlan={selectedPlan}
            values={values}
            fetchSubscriptions={fetchSubscriptions}
            showSuccess={showSuccess}
            showError={showError}
            treeData={treeData}
            setTreeData={setTreeData}
            features={features}
            isDialog={isDialog}
            toggleFeature={toggleFeature}
            handleSubmit={handleSubmit}
            editableBody={editableBody}
            editingData={editingData}
            addNewPlan={addNewPlan}
            actionBody={actionBody}
            openEditor={openEditor}
            deletePlan={deletePlan}
            clientPlans={clientPlans}
            selectedPlanId={selectedPlanId}
            setSelectedPlanId={setSelectedPlanId}
            setMonthlyPrice={setMonthlyPrice}
            setAnnualPrice={setAnnualPrice}
            selectedCycle={selectedCycle}
          />

        </TabPanel>

        <TabPanel header="Agents" className="clients-tab-content">



          <AgentsPlans
            plans={plans}
            agentPlans={agentPlans}
            setPlans={setAgentPlans}
            selectedPlan={selectedPlan}
            values={values}
            fetchSubscriptions={fetchSubscriptions}
            showSuccess={showSuccess}
            showError={showError}
            treeData={treeData}
            setTreeData={setTreeData}
            features={features}
            isDialog={isDialog}
            toggleFeature={toggleFeature}
            handleSubmit={handleSubmit}
            editableBody={editableBody}
            editingData={editingData}
            addNewPlan={addNewPlan}
            actionBody={actionBody}
            openEditor={openEditor}
            deletePlan={deletePlan}
            planType="agent"

          />

        </TabPanel>
        <TabPanel header="Brokers" className="clients-tab-content">

          <AgentsPlans
            plans={plans}
            agentPlans={brokerPlans}
            setPlans={setBrokerPlans}
            selectedPlan={selectedPlan}
            values={values}
            fetchSubscriptions={fetchSubscriptions}
            showSuccess={showSuccess}
            showError={showError}
            treeData={treeData}
            setTreeData={setTreeData}
            features={features}
            isDialog={isDialog}
            toggleFeature={toggleFeature}
            handleSubmit={handleSubmit}
            editableBody={editableBody}
            editingData={editingData}
            addNewPlan={addNewPlan}
            actionBody={actionBody}
            openEditor={openEditor}
            deletePlan={deletePlan}
            planType="broker"
          
          />

        </TabPanel>

      
        <TabPanel
          header="Transaction Summary"
          className="clients-tab-content"
        >
          <div className="card">
            <DataTable
              value={users} 
              className="transaction-summary-table"
              paginator
              rows={10}
              responsiveLayout="scroll"
              header={tableHeader}
              globalFilter={globalFilter}
              sortField="updatedAt"
              sortOrder={-1}
            >
              <Column
                field="firstName"
                header="First Name"
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="lastName"
                header="Last Name"
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="email"
                header="Email"
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="roleId"
                header="Role"
                sortable
                body={(rowData) => rowData.role?.name || 'N/A'}
                style={{ minWidth: "100px" }}
              />
              <Column
                field="brokerId"
                header="Broker"
                body={(rowData) => rowData.broker ? rowData.broker?.firstName + " " + rowData.broker?.lastName : ''}
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="agentId"
                header="Agent"
                body={(rowData) => rowData.agent ? rowData.agent?.firstName + " " + rowData.agent?.lastName : ''}
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="planName"
                header="Plan Name"
                body={(rowData) => rowData.user_subscriptions[0]?.subscription_plan?.name || ''}
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="price"
                header="Price"
                sortable
                body={(rowData) => {
                  const subscription = rowData.user_stripe_payments?.[0];
                  const original_amount = subscription?.original_amount;
                  const coupon_discount = subscription?.coupon_discount;

                  if (original_amount) {
                    // If coupon_discount is not null, return original_amount - coupon_discount, else return original_amount
                    if (coupon_discount !== null && coupon_discount !== undefined && coupon_discount > 0) {
                      return `$${original_amount - coupon_discount}`;
                    } else {
                      return `$${original_amount}`;
                    }
                  }
                  return '$0';
                }}
                style={{ minWidth: "100px", textAlign: "right" }}
              />
              <Column
                field="billingCycle"
                header="Billing Cycle"
                body={(rowData) => {
                  const billingCycle = rowData.user_subscriptions[0]?.billing_cycle || '-';
                  return billingCycle.charAt(0).toUpperCase() + billingCycle.slice(1);
                }}
                sortable
                style={{ minWidth: "120px" }}
              />
              <Column
                field="createdAt"
                header="Start Date"
                sortable
                body={(rowData) => formatDate(rowData.createdAt)}
                style={{ minWidth: "120px" }}
              />
              <Column
                field="end_date"
                header="Subscription End Date"
                sortable
                body={(rowData) => (rowData.user_subscriptions[0]?.end_date ? (formatDate(rowData.user_subscriptions[0]?.end_date)) : '-')}
                style={{ minWidth: "120px" }}
              />
              <Column
                field="status"
                header="Status"
                sortable
               
                style={{ minWidth: "100px" }}
              />
          
            </DataTable>
          </div>
        </TabPanel>
        <TabPanel header="Coupons" className="coupons-tab-content">
          <Coupons />
        </TabPanel>


      </TabView>

    </div>
  );
};


const ClientsPlans = ({ stripe, plans, setPlans, selectedPlan, values, fetchSubscriptions, showSuccess, showError, treeData, setTreeData, features, isDialog, toggleFeature, handleSubmit, editableBody, addNewPlan, actionBody, clientPlans, openEditor, deletePlan, selectedPlanId, setSelectedPlanId, setMonthlyPrice, setAnnualPrice, selectedCycle }) => {

  const [showFeatureDialog, setShowFeatureDialog] = useState(false);
  const [selectedPlanForFeatures, setSelectedPlanForFeatures] = useState(null);

  const [expandedKeys, setExpandedKeys] = useState({});

  const accessTemplate = (nodeData) => {
    const accessLevels = ['None', 'Read', 'Partial', 'Full'];
    const currentAccess = nodeData.access || 'None';

    return (
      <Dropdown
        value={currentAccess}
        options={accessLevels}
        onChange={(e) => {
          // Update the access level in treeData
          const updateNodeAccess = (nodes, key, newAccess) => {
            return nodes.map(node => {
              if (node.key === key) {
                return { ...node, data: { ...node.data, access: newAccess } };
              }
              if (node.children) {
                return { ...node, children: updateNodeAccess(node.children, key, newAccess) };
              }
              return node;
            });
          };

          setTreeData(prevData => updateNodeAccess(prevData, nodeData.key, e.value));
        }}
        style={{ width: '100px' }}
      />
    );
  };


  // TreeTable templates - cascade structure with categories
  const categoryNameTemplate = (node) => {
    const isCategory = node.data?.type === 'category';
    return (
      <span className={isCategory ? 'category-name' : 'feature-name'}>
        {node.data?.name}
      </span>
    );
  };
  const featureSelectionBody = (rowData) => {
    return (

      <a
        href="javascript:;"
        onClick={() => {
          setSelectedPlanForFeatures(rowData);
          setShowFeatureDialog(true);

        }}
      >
        Update
      </a>
    );
  };
  const featureAccessTemplate = (plan) => (node) => {
    const isCategory = node.data?.type === 'category';

    if (isCategory) {
      return <span></span>; // Empty for category rows
    }

    // Find the original feature from features array to get correct access data
    const originalFeature = features.find(f => f.id === node.data?.id);
    const accessData = originalFeature?.access || {};

    return (
      <Checkbox
        checked={Boolean(accessData[plan.name])}
        disabled={isDialog}
        onChange={(e) => toggleFeature(node.data?.id, plan, e.checked)}
      />
    );
  };

  return (
    <div>

      {/* Add button */}
      <div className="flex">
      <div className="col-11"></div>
      <div className="col-1 flex justify-content-end mb-3">

        <Button
          label="Add"
          
          className="p-button-warning p-button-raised w-100"
          onClick={addNewPlan}
        />

      </div>
      </div>
      <DataTable
        value={clientPlans}
        className="clients-plans-table"
        paginator
        style={{ "width": "87.5vw" }}
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"

      >

        <Column style={{"width":"10px"}} header="ID" body={(data, options) => options.rowIndex + 1} />
        <Column
          field="name"
          header="Plan"
          body={(rowData) => editableBody(rowData, 'name')}
          className="plan-name-column"
        />

        <Column
          field="monthly_price"
          header="Billing Monthly"
          body={(rowData) => editableBody(rowData, 'monthly_price')}
          className="price-column"
        />

        <Column
          field="annual_price"
          header="Billing Yearly"
          body={(rowData) => editableBody(rowData, 'annual_price')}
          className="price-column"
        />

        <Column
          header="Manage Features"
          body={(rowData) => featureSelectionBody(rowData)}
          className="features-column"
        />

        <Column
          field="features"
          header="Plan Highlights"
          body={(rowData) => editableBody(rowData, 'features')}
          className="features-column"
        />

        <Column body={(rowData) => editableBody(rowData, 'startDate')} header="Start Date" className="date-column" />
        <Column body={(rowData) => editableBody(rowData, 'endDate')} field="endDate" header="End Date" className="date-column" />
        <Column
          field="is_active"
          header="Status"
          body={(rowData) => editableBody(rowData, 'is_active')}
          className="status-column"
        />
       
        <Column header="Action" body={actionBody} className="action-column" />

      </DataTable>
      

      {/* Feature Selection Dialog */}
      <Dialog
        visible={showFeatureDialog}
        onHide={() => setShowFeatureDialog(false)}
        header={`Update Features - ${selectedPlanForFeatures?.name || 'Plan'}`}
        style={{ width: '60vw', height: '70vh' }}
        modal
        resizable
      >
        <div style={{ height: '50vh', overflow: 'auto' }}>
          <TreeTable
            value={treeData}
            expandedKeys={expandedKeys}
            onToggle={e => setExpandedKeys(e.value)}
            scrollHeight="400px"
            responsiveLayout="scroll"
            scrollDirection="both"
            className="fontLabel p-datatable-striped p-datatable-sm p-datatable-customers subscription-treetable"
          >
            <Column
              field="name"
              body={categoryNameTemplate}
              expander={true}
              style={{ width: '60%' }}
            />

            <Column

              body={featureAccessTemplate(selectedPlanForFeatures)}
              expander={false}
              style={{ width: '40%', textAlign: 'center' }}
            />

          </TreeTable>
        </div>

        <div className="flex justify-content-end gap-2 mt-4">
          <Button
            label="Cancel"
            className="p-button-raised p-button-lg"
            onClick={() => setShowFeatureDialog(false)}
          />
          <Button
            label="Save Features"
            className="p-button-raised p-button-lg p-button-warning"
            onClick={(e) => {
              // Check if the plan exists in database (has an ID)
              if (!selectedPlanForFeatures?.id) {
                showError("Please save the plan first before configuring features");
                return;
              }
              // Handle saving features
              handleSubmit(e, selectedPlanForFeatures);
              setShowFeatureDialog(false);
              showSuccess("Features updated successfully");
            }}
          />
        </div>
      </Dialog>

    </div>
  );
};
const AgentsPlans = ({ plans, setPlans, selectedPlan, values, fetchSubscriptions, showSuccess, showError, treeData, setTreeData, features, isDialog, toggleFeature, handleSubmit, editableBody, editingData, addNewPlan
  , actionBody, openEditor, deletePlan, agentPlans, planType = 'agent'
}) => {

  return (
    <div>
      {/* Add button */}
      <div className="flex">
      <div className="col-11"></div>
      <div className="col-1 flex justify-content-end mb-3">


        <Button
          label="Add"
          className="p-button-warning p-button-raised w-100"
          onClick={addNewPlan}
        />
      </div>
      </div>
      <DataTable
        value={agentPlans}
        className="clients-plans-table"
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      >
        <Column header="ID" body={(data, options) => options.rowIndex + 1} />
        <Column
          field="name"
          header="Plan"
          body={(rowData) => editableBody(rowData, 'name')}
          className="plan-name-column"
        />
        <Column
          field="monthly_price"
          header={"Monthly Cost"}
          body={(rowData) => editableBody(rowData, 'monthly_price')}
          className="price-column"
        />

        <Column
          field="annual_price"
          header={"Yearly Cost"}
          body={(rowData) => editableBody(rowData, 'annual_price')}
          className="price-column"
        />
        <Column
          field="features"
          header={planType === 'agent' ? "Min Clients" : "Min Agents"}
          body={(rowData) => editableBody(rowData, planType === 'agent' ? 'min_clients' : 'min_clients')}
          className="features-column"
        />

        <Column
          field="features"
          header={planType === 'agent' ? "Max Clients" : "Max Agents"}
          body={(rowData) => editableBody(rowData, planType === 'agent' ? 'max_clients' : 'max_clients')}
          className="features-column"
        />

        {planType === 'broker' && (
          <Column
            field="features"
            header="Min Clients Per Agent"
            body={(rowData) => editableBody(rowData, 'min_clients_per_agent')}
            className="features-column"
          />
        )}

        {planType === 'broker' && (
          <Column
            field="features"
            header="Max Clients Per Agent"
            body={(rowData) => editableBody(rowData, 'max_clients_per_agent')}
            className="features-column"
          />
        )}

        <Column
          field="features"
          header="Plan Highlights"
          body={(rowData) => editableBody(rowData, 'features')}
          className="features-column"
        />

        <Column body={(rowData) => editableBody(rowData, 'startDate')} header="Start Date" className="date-column" />
        <Column body={(rowData) => editableBody(rowData, 'endDate')} field="endDate" header="End Date" className="date-column" />
        <Column
          field="is_active"
          header="Status"
          body={(rowData) => editableBody(rowData, 'is_active')}
          className="status-column"
        />
         <Column
          field="plan_category"
          header="Plan Category"
          body={(rowData) => editableBody(rowData, 'plan_category')}
          className="status-column"
          style={{ display: planType === 'agent' ? 'table-cell' : 'none' }}
        />

        <Column header="Action" body={actionBody} className="action-column" />

      </DataTable>

    </div>
  );
}
export default Subscription;
